export default {
  title: 'Vitrine',
  fields: {
    has_reservations: {
      label: 'Afficher les réservations sur la vitrine',
    },
  },
  button: {
    save: 'Enregistrer',
    preview: 'Aperçu',
  },
  no_storefront: {
    title: 'Aucune vitrine trouvée',
    description: 'Veuillez créer une vitrine.',
    button: {
      storefront: 'Aller à la vitrine',
    },
  },
  response_messages: {
    success: 'Mis à jour avec succès.',
    failed: 'Échec de la mise à jour.',
  },
};
